import styled from "styled-components";

const Wrapper = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const Loader = styled.span`
	width: ${props => props.width || '50px'};
	height: ${props => props.height || '50px'};
	display: block;
	border-radius: 50%;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #ccc;
	animation: spin 2s linear infinite;

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
`;

const LoaderWrapper = (props) => {
	return (<Wrapper>
		<Loader {...props} />
	</Wrapper>);
}

export default LoaderWrapper;
